
import {FlowFile} from "../../../../lib/src/api/repositories/flows-repository";
import {FC} from "react";
import DataTable from "../../../../lib/src/components/data-table/DataTable";

export const FlowFilesTable: FC<{isLoading: boolean, files: FlowFile[]}> = props => {
  const sortedFiles = props.files.sort((a,b) => a.name.localeCompare(b.name))

  return <DataTable keyProperty={'id'} loading={props.isLoading} data={sortedFiles} columns={[
    {property: 'name', header: 'Naam'},
    {property: 'type', header: 'Type'},
    {property: 'created_at', header: 'Aangemaakt', transform: (created_at) => new Date(created_at).toLocaleDateString('nl-NL', {year: 'numeric', month: '2-digit', day: '2-digit'})},
  ]} placeholder={'Nog geen bestanden'}/>
}